import {
  Elements,
  PaymentElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useEffect, useState } from "react";
import ApiService from "../../services/ApiService";
import { useTranslation } from "react-i18next";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const CombinedStripeCheckout = ({
  onNext,
  selectedTalentData,
  setPaymentInfo,
}) => {
  const [clientSecret, setClientSecret] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { t } = useTranslation();

  console.log(selectedTalentData)
  
  useEffect(() => {
    const createPaymentIntent = async () => {
      if (!selectedTalentData?.total_amount) {
        console.error("Missing total_amount in selectedTalentData", selectedTalentData);
        setError(t("payment_init_error") + ": Invalid Amount");
        setLoading(false);
        return;
      }

      try {
        const response = await ApiService.request({
          method: "POST",
          url: "company/stripePayment",
          data: { amount: selectedTalentData.total_amount },
        });
        setClientSecret(response.data.paymentIntent); 
      } catch (err) {
        console.error("Stripe Payment Intent Error:", err);
        setError(t("payment_init_error"));
      } finally {
        setLoading(false);
      }
    };

    createPaymentIntent();
  }, [selectedTalentData, t]);

  if (loading) {
    return <div>{t("loading_stripe")}...</div>;
  }

  if (error) {
    return <div className="text-danger">{error}</div>;
  }

  if (!clientSecret) {
    return <div className="text-danger">{t("payment_init_error")}</div>;
  }

  return (
    <Elements stripe={stripePromise} options={{ clientSecret }}>
      <CheckoutForm
        onNext={onNext}
        selectedTalentData={selectedTalentData}
        setPaymentInfo={setPaymentInfo}
      />
    </Elements>
  );
};

const CheckoutForm = ({ onNext, selectedTalentData, setPaymentInfo }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [succeeded, setSucceeded] = useState(false);
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  console.log("ks", selectedTalentData)

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
  
    if (!stripe || !elements) {
      setLoading(false);
      setError(t("stripe_not_loaded"));
      return;
    }
  
    try {
      const { error: stripeError, paymentIntent } = await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: window.location.href,
        },
        redirect: "if_required",
      });
  
      if (stripeError) {
        setError(stripeError.message);
        return;
      }
  
      if (paymentIntent && paymentIntent.status === "succeeded") {
        setSucceeded(true);
        setPaymentInfo(paymentIntent);
  
        try {
          await ApiService.request({
            method: "POST",
            url: "company/updatePaymentStatus",
            headers: {
              "Content-Type": "multipart/form-data",
            },
            data: {
              project_id: selectedTalentData._id,
              transaction_id: paymentIntent.id,
              amount: selectedTalentData.total_amount,
              payment_method: "Card",
            },
          });
          onNext();
        } catch (apiError) {
          setError(t("payment_status_update_error"));
          console.error(apiError);
        }
      }
    } catch (err) {
      setError(t("unexpected_error"));
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div style={{ 
      maxWidth: "500px", 
      margin: "0 auto", 
      padding: "20px",
      // Remove direction and textAlign from main container to not affect Stripe
    }}>
      {/* Only apply RTL to the heading, not the Stripe form */}
      <h3 style={{ 
        textAlign: isRTL ? "right" : "left",
        direction: isRTL ? "rtl" : "ltr"
      }}>
        {t("new_text_67")}
      </h3>
      
      {/* Stripe PaymentElement container - keep it LTR always */}
      <div style={{
        direction: "ltr", // Force LTR for Stripe form
        textAlign: "left" // Force left alignment for Stripe form
      }}>
        <form onSubmit={handleSubmit}>
          <PaymentElement options={{ layout: "tabs" }} />
          
          <button
            type="submit"
            disabled={!stripe || loading}
            style={{
              marginTop: "20px",
              background: "#FF6237",
              color: "white",
              padding: "12px 24px",
              borderRadius: "4px",
              fontSize: "16px",
              border: "none",
              cursor: "pointer",
              width: "100%",
            }}
          >
            {loading
              ? t("processing")
              : `${t("new_text_60")} ${selectedTalentData.total_amount} AED`}
          </button>
        </form>
      </div>

      {/* Error and success messages with RTL support */}
      {error && (
        <div style={{ 
          color: "red", 
          marginTop: "12px",
          textAlign: isRTL ? "right" : "left",
          direction: isRTL ? "rtl" : "ltr"
        }}>
          {error}
        </div>
      )}
      {succeeded && (
        <div style={{ 
          color: "green", 
          marginTop: "12px",
          textAlign: isRTL ? "right" : "left",
          direction: isRTL ? "rtl" : "ltr"
        }}>
          {t("payment_succeeded")}
        </div>
      )}
    </div>
  );
};

export default CombinedStripeCheckout;
